(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vector-mesh", [], factory);
	else if(typeof exports === 'object')
		exports["vector-mesh"] = factory();
	else
		root["vector-mesh"] = factory();
})(self, function() {
return 